import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserData } from '../services/user-data/user-data';
@Injectable({providedIn:'root'})
export class MemberGuard implements CanActivate {
 constructor(private router:Router,private userData:UserData){}
 canActivate(route?:ActivatedRouteSnapshot,state?:RouterStateSnapshot):boolean|UrlTree{
  if(this.userData.isMemberSession())return true;
  const url=state?.url || '';
  if(/^\/(collaborate\/[a-f0-9]{64}|collaboration-contribution\/[1-9][0-9]*\/[1-9][0-9]*|media\/[1-9][0-9]*|acquire\/[1-9][0-9]*|trade-checkout\/[1-9][0-9]*)$/.test(url)){
   try{sessionStorage.setItem('rv-auth-return',url);}catch(_){}
   return this.router.createUrlTree(['/login']);
  }
  return this.router.createUrlTree(['/guest']);
 }
}
